interface UseKeywordManagementProps {
  tagNameSearch: string
  tagDescriptionSearch: string
  tagNameKeywords: string[]
  tagDescriptionKeywords: string[]
  setTagNameKeywords: (
    keywords: string[] | ((prev: string[]) => string[])
  ) => void
  setTagDescriptionKeywords: (
    keywords: string[] | ((prev: string[]) => string[])
  ) => void
  setTagNameSearch: (search: string) => void
  setTagDescriptionSearch: (search: string) => void
}

export interface UseKeywordManagementReturn {
  handleAddTagNameKeyword: () => void
  handleAddTagDescriptionKeyword: () => void
  handleRemoveTagNameKeyword: (keywordToRemove: string) => void
  handleRemoveTagDescriptionKeyword: (keywordToRemove: string) => void
  handleTagNameKeyDown: (e: React.KeyboardEvent) => void
  handleTagDescriptionKeyDown: (e: React.KeyboardEvent) => void
}

export const useKeywordManagement = ({
  tagNameSearch,
  tagDescriptionSearch,
  tagNameKeywords,
  tagDescriptionKeywords,
  setTagNameKeywords,
  setTagDescriptionKeywords,
  setTagNameSearch,
  setTagDescriptionSearch,
}: UseKeywordManagementProps): UseKeywordManagementReturn => {
  const addKeyword = (
    searchValue: string,
    keywords: string[],
    setKeywords: (keywords: string[] | ((prev: string[]) => string[])) => void,
    setSearch: (search: string) => void
  ) => {
    const trimmedKeyword = searchValue.trim()
    if (
      trimmedKeyword &&
      !keywords.some(
        (keyword) => keyword.toLowerCase() === trimmedKeyword.toLowerCase()
      )
    ) {
      setKeywords((prev) => [...prev, trimmedKeyword])
      setSearch('')
    }
  }

  const removeKeyword = (
    keywordToRemove: string,
    setKeywords: (keywords: string[] | ((prev: string[]) => string[])) => void
  ) => {
    setKeywords((prev) => prev.filter((keyword) => keyword !== keywordToRemove))
  }

  const handleAddTagNameKeyword = () => {
    addKeyword(
      tagNameSearch,
      tagNameKeywords,
      setTagNameKeywords,
      setTagNameSearch
    )
  }

  const handleAddTagDescriptionKeyword = () => {
    addKeyword(
      tagDescriptionSearch,
      tagDescriptionKeywords,
      setTagDescriptionKeywords,
      setTagDescriptionSearch
    )
  }

  const handleRemoveTagNameKeyword = (keywordToRemove: string) => {
    removeKeyword(keywordToRemove, setTagNameKeywords)
  }

  const handleRemoveTagDescriptionKeyword = (keywordToRemove: string) => {
    removeKeyword(keywordToRemove, setTagDescriptionKeywords)
  }

  const handleTagNameKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      handleAddTagNameKeyword()
    }
  }

  const handleTagDescriptionKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      handleAddTagDescriptionKeyword()
    }
  }

  return {
    handleAddTagNameKeyword,
    handleAddTagDescriptionKeyword,
    handleRemoveTagNameKeyword,
    handleRemoveTagDescriptionKeyword,
    handleTagNameKeyDown,
    handleTagDescriptionKeyDown,
  }
}
